import { EventCategory, fromEnumAsString, toEnumFromStringOrNull } from 'in-time-core';

export function getRouteForEventCategory(category: EventCategory): string {
  const categoryName = fromEnumAsString(category).toLowerCase();

  return `/${categoryName}`;
}

export function getEventCategoryForRouteParam(param: string): EventCategory | null {
  const category = param.toUpperCase();

  return toEnumFromStringOrNull(category, EventCategory);
}
